/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2541
 */

var r = require(/* 864 */"./864")
var i = require(/* 862 */"../../../../2466/1167/1431/862/index")
module.exports = function (e, t) {
  return e && r(t, i(t), e)
}
